module.exports = __webpack_public_path__ + "img/person-working.21787edc.svg";